import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { Language } from "../i18n";

interface AppState {
  language?: Language;
  setLanguage: (language?: Language) => void;
}

const useAppState = create<AppState>()(
  devtools(
    persist(
      (set) => ({
        language: "en",
        setLanguage: (language) => set({ language }),
      }),
      {
        name: "app-state",
      },
    ),
  ),
);

export default useAppState;
